import { Link } from 'react-router-dom';

const menuItems = [
  { label: 'Create course', path: '/editor/course/new' },
  { label: 'Edit course', path: '/courses' },
  { label: 'Course drafts', path: '/editor/course-drafts' },
  { label: 'My draft', path: '/drafts', activePaths: ['/drafts', '/draft'] },
  { label: 'My contribution' },
  { label: 'Review contributions' },
  { label: 'Editor Playground', path: '/editor/playground' },
  { label: 'Markup Documentation', path: '/editor/doc/editor/markup' },
];

export default function EditorNavigationMenu({ currentPage }) {
  return (
    <>
      {menuItems.map(({ label, path, activePaths }) => (
        <li key={label}>
          {path ? (
            <Link className="navigation__editor-link" to={path} aria-current={currentPage(...(activePaths ?? [path]))}>
              {label}
            </Link>
          ) : (
            <span className="navigation__unavailable" aria-disabled="true">{label}</span>
          )}
        </li>
      ))}
    </>
  );
}
